<template>
<div class="chapter">
<div class="inner_page">
<div class="bg1">
<div class="img_container"><a id="page_10"></a>
<img alt="Images" src="images/f0010-1.jpg"/>
</div>
<div class="img_container"><a id="page_11"></a>
<img alt="Images" src="images/f0011-1.jpg"/>
<p class="cap"><em class="italic">Thirty years after SOG’s dissolution, the top secret unit’s existence was acknowledged with a Presidential Unit Citation, America’s highest such award. More than 200 veterans of SOG’s secret war assembled at Fort Bragg, North Carolina, on 1 April 2001, for the Citation’s formal presentation, which hailed their “officially denied operations” and “unacknowledged sacrifices.”</em></p>
<p class="capa"><em class="italic">As of this writing, the Vietnamese government has refused to admit capturing any of SOG’s 57 MIAs, though some remains have been recovered from downed aircraft sites.</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Front.vue?520b0d8c